import { styled } from "@mui/material/styles";
import React, { createContext, useContext, useLayoutEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { BackButton } from "./Button";
const Bar = styled("header")({
    position: "relative",
    zIndex: 2,
    height: "var(--j-hdr)",
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    gap: "var(--j-sp-1)",
    padding: "0 var(--j-sp-1) 0 var(--j-sp-2)",
    background: "var(--j-surface)",
    borderBottom: "1px solid var(--j-line)",
    "@media (max-width: 340px)": {
        gap: "var(--j-sp-0-5)",
        padding: "0 var(--j-sp-1)"
    },
    "& .bar-title": {
        flex: 1,
        minWidth: 0,
        fontSize: "var(--j-fs-lg)",
        lineHeight: "var(--j-lh-lg)",
        fontWeight: 600,
        letterSpacing: "-0.006em",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        margin: 0
    },
    "& > .bar-middle": {
        flex: 1,
        minWidth: 0,
        alignSelf: "stretch",
        display: "flex",
        alignItems: "center"
    },
    "& > .bar-middle > *": {
        flex: 1,
        minWidth: 0
    },
    "&[data-centered=true]": {
        display: "grid",
        gridTemplateColumns: "1fr minmax(0, auto) 1fr",
        "& > .bar-start": {
            justifySelf: "start",
            minWidth: 0
        },
        "& > .bar-end": {
            justifySelf: "end"
        },
        "& .bar-title": {
            textAlign: "center"
        }
    }
});
export const Wordmark = styled("div")({
    fontSize: "var(--j-fs-lg)",
    lineHeight: "var(--j-lh-lg)",
    fontWeight: 600,
    letterSpacing: "-0.006em",
    color: "var(--j-ink)"
});
export function TopBar({ start, title, children, end, centered = false, className }) {
    if (centered) {
        return /*#__PURE__*/ React.createElement(Bar, {
            className: className,
            "data-has-start": !!start,
            "data-centered": true
        }, /*#__PURE__*/ React.createElement("div", {
            className: "bar-start"
        }, start), /*#__PURE__*/ React.createElement("h2", {
            className: "bar-title"
        }, title), /*#__PURE__*/ React.createElement("div", {
            className: "bar-end"
        }, end));
    }
    const hasMiddle = !!title || !!children;
    return /*#__PURE__*/ React.createElement(Bar, {
        className: className,
        "data-has-start": !!start
    }, start, title && /*#__PURE__*/ React.createElement("h2", {
        className: "bar-title"
    }, title), children && /*#__PURE__*/ React.createElement("div", {
        className: "bar-middle"
    }, children), !hasMiddle && /*#__PURE__*/ React.createElement("div", {
        className: "bar-middle"
    }), end);
}
export const ShellBarContext = /*#__PURE__*/ createContext({
    slot: null,
    setPushed: ()=>undefined
});
export function PushedBar({ onBack, backLabel, title, end }) {
    const { slot, setPushed } = useContext(ShellBarContext);
    const backRef = useRef(null);
    const [previous] = useState(()=>document.activeElement);
    useLayoutEffect(()=>{
        setPushed(true);
        backRef.current?.focus();
        return ()=>{
            setPushed(false);
            requestAnimationFrame(()=>{
                const active = document.activeElement;
                if ((!active || active === document.body) && previous?.isConnected) previous.focus();
            });
        };
    }, [
        setPushed,
        previous
    ]);
    const bar = /*#__PURE__*/ React.createElement(TopBar, {
        centered: !!title,
        start: /*#__PURE__*/ React.createElement(BackButton, {
            ref: backRef,
            onClick: onBack
        }, backLabel),
        title: title,
        end: end
    });
    return slot ? /*#__PURE__*/ createPortal(bar, slot) : bar;
}
